import DetailTemplate from '@/components/detail-template'
import React, { useEffect, useMemo, useState } from 'react'
import { displayModel, PluginDetailProps } from './display-model'

import {
  useGetAttackTypeList,
  useGetDetailAttCkList,
  useGetTagTreeOptions,
  useResultResourceDetail,
  useResultDefenseRankings,
  useResultDetail,
  useUpdateResourceInterceptStatus,
  useResultResourceList,
  useGetResultInfo,
  useGetFailPluginLog,
  useGetOfflineLogImportInfo,
  useDeleteOfflineLogImportInfo,
  useGetAttackDefenseRanking,
  useGetAttachmentTypeRanking,
  useGetRiskLevelDistribution,
  useGetResourceLevelsRanking,
  useGetTemplateLoseEfficacyRanking,
  useGetVerifyDistribution,
  useGetDeviceProtectionList,
  useGetTaskScore,
  useGetExecuteInfo,
  useGetSubTaskFilterData,
  useGetAPTList,
  useGetAttckCascaderData,
} from './utils'
import { useDeleteList } from '../task-list/utils'
import { useAddReport } from '@/pages/evaluation/report-task/utils'

import styled from 'styled-components'
import {
  Button,
  Checkbox,
  Divider,
  Empty,
  Form,
  Image,
  Progress,
  Select,
  Tabs,
  Typography,
  Tooltip,
  Space,
} from 'antd'
import {
  DeleteModal,
  IconFont,
  ImportModal,
  RecordModal,
  SvgIcon,
  TableTag,
  TagSearchOption,
  BasTitle,
} from '@/components'
import { CheckOutlined } from '@ant-design/icons'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import ProgressInfo, { ProgressItem } from '@/components/detail-template/widgets/progress-info'
import FailedTabs from '@/components/detail-template/widgets/failed-tabs'
import { OptionType } from '@/components/detail-template/widgets/search-panel'
import leakSeverity from '@/assets/imges/leak-severity.png'
import leakCenter from '@/assets/imges/leak-center.png'
import leakLow from '@/assets/imges/leak-low.png'
import leakHigh from '@/assets/imges/leak-high.png'
import TaskCharts from './task-charts'
import { DetailDrawer } from './detail-drawer'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CreateReport } from '@/components/create-report'
import { uniqBy } from 'lodash'
import ProgressContent from '@/components/detail-template/widgets/progress-content'
import { FilterDropdownProps } from 'antd/lib/table/interface'
import { formatTimeInterval } from '@/utils'
import { formatDateTime } from '@/utils/date'
import { t } from '@/i18n'

const { Text } = Typography
const { useForm } = Form
const { Item } = Form
const { Group } = Checkbox

const Detail: React.FC = () => {
  const navigate = useNavigate()
  const [form] = useForm()
  const [searchParams] = useSearchParams()
  const task_id = searchParams.get('task_id') as string
  const id = searchParams.get('id') as string
  const userId = JSON.parse(localStorage.getItem('token') || '{}').id
  // 获取任务信息
  const [taskInfo, getTaskInfo, taskInfoLoading] = useGetResultInfo()
  const [attackTypeList, getAttackTypeList] = useGetAttackTypeList()
  // 获取att&ck
  // const [getDetailAttCkList, detailAttCkList] = useGetDetailAttCkList()
  // 获取attck级联数据
  const [getAttckCascaderData, attckCascaderData] = useGetAttckCascaderData()
  // 执行信息
  const [getExecuteInfo, executeInfo] = useGetExecuteInfo()
  // 获取攻击组织
  const [getAPTList, aptList] = useGetAPTList()
  // 用例标签
  const [getTagTreeOptions, tagTreeOptions] = useGetTagTreeOptions()
  // 获取用例列表
  const [useCaseDataList, getUseCaseList, useCaseListLoading] = useResultResourceList()
  // 修改拦截状态
  const [updateResourceInterceptStatus, updateInterceptStatusLoading] =
    useUpdateResourceInterceptStatus()
  // 获取发送失败日志
  const [failData, getFailPluginLog] = useGetFailPluginLog()

  // 设备防护列表
  const [getDeviceProtectionList, deviceProtectionList] = useGetDeviceProtectionList()
  // 攻击防护排名
  const [getAttackDefenseRanking, attackDefenseRanking] = useGetAttackDefenseRanking()
  // 附件类型排名
  const [getAttachmentTypeRanking, attachmentTypeRanking] = useGetAttachmentTypeRanking()
  // 危险等级分布
  const [getRiskLevelDistribution, riskLevelDistribution] = useGetRiskLevelDistribution()
  // 用例等级分布
  const [getResourceLevelsRanking, resourceLevelsRanking] = useGetResourceLevelsRanking()
  // 模板防护失效率排名
  const [getTemplateLoseEfficacyRanking, templateLoseEfficacyRanking] =
    useGetTemplateLoseEfficacyRanking()
  // 验证结果分布
  const [getVerifyDistribution, verifyDistribution] = useGetVerifyDistribution()
  // 任务评分
  const [getTaskScore, taskScore] = useGetTaskScore()
  // 子任务过滤数据
  const [getSubTaskFilterData, subTaskFilterData] = useGetSubTaskFilterData()

  // 获取离线日志导入信息
  const [getOfflineLogInfo, importRecord] = useGetOfflineLogImportInfo()
  // 删除日志设备导入记录
  const [deleteOfflineLogInfo, deleteRecordLoading] = useDeleteOfflineLogImportInfo()
  // 生成报表
  const [generateReport, createLoading] = useAddReport()
  // 删除任务
  const [deleteTask] = useDeleteList()
  // 抽屉详情
  const [resultResourceDetail, getResultResourceDetail, detailLoading] = useResultResourceDetail()
  const { taskInfoExpanded, taskInfo: taskInfoModel } = displayModel

  const [executeTimeId, setTimeId] = useState(id)
  // 控制 payload日志 显隐
  const [logInfo, setLogInfo] = useState<{ visible: boolean; content: string[]; id: string }>({
    visible: false,
    content: [],
    id: '',
  })
  // 控制 发送失败payload日志 显隐
  const [failLogInfo, setFailLogInfo] = useState<{ visible: boolean; content: [] }>({
    visible: false,
    content: [],
  })
  // 筛选条件
  const [filterParams, setFilterParams] = useState({
    page: 1,
    limit: 20,
  })
  // 筛选框
  const [filterFormValue, setFilterFormValue] = useState<{
    field: string | number
    value: string | number | string[] | number[] | undefined
  }>({
    field: '',
    value: '',
  })
  // 用例列表
  const [useCaseList, setUseCaseList] = useState<any[]>([])
  // 用例总数
  const [useCaseTotal, setUseCaseTotal] = useState(0)
  // 修正用例数量
  const [fixPayloadCount, setFixPayloadCount] = useState(0)
  // 选中项的 key 数组
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])
  // 触发进度信息刷新数据
  const [random, setRandom] = useState(0)
  // 控制 卡片 高亮
  const [cardActive, setCardActive] = useState('')
  // 导入记录弹窗 visible
  const [recordVisible, setRecordVisible] = useState(false)
  // 导入离线日志弹窗 visible
  const [importVisible, setImportVisible] = useState(false)
  // 生成报表弹窗 visible
  const [reportVisible, setReportVisible] = useState({
    visible: false,
    result_id: id,
    name: taskInfo.task_name,
  })
  const [resourceType, setResourceType] = useState(8)
  // 删除弹窗 visible
  const [deleteVisible, setDeleteVisible] = useState(false)
  // 控制 详情抽屉 显隐
  const [detailDrawerVisible, setDetailDrawerVisible] = useState(false)
  // 详情抽屉 数据
  const [pluginDetail, setPluginDetail] = useState<PluginDetailProps>()
  // 批量修正弹窗
  const [fixedModalVisible, setFixedModalVisible] = useState(false)
  const [activeTab, setActiveTab] = useState('failed')
  const [infoActiveTab, setInfoActiveTab] = useState('taskTemplate')
  // 进度内容列表
  const [progressContentList, setProgressContentList] = useState<any[]>([])

  const [riskLevelSelectOpen, setRiskLevelSelectOpen] = useState(false)
  const [attackTypeSelectOpen, setAttackTypeSelectOpen] = useState(false)
  const [resourceLevelSelectOpen, setResourceLevelSelectOpen] = useState(false)
  const [interceptStatusSelectOpen, setInterceptStatusSelectOpen] = useState(false)
  const [deviceStatusSelectOpen, setDeviceStatusSelectOpen] = useState(false)
  const [failedCaseList, setFailedCaseList] = useState<{
    caseInfo: any[]
    total: number
  }>({
    caseInfo: [],
    total: 0,
  })
  const [unsentCaseList, setUnsentCaseList] = useState<{
    caseInfo: any[]
    total: number
  }>({
    caseInfo: [],
    total: 0,
  })
  const riskLevelMap = {
    0: { label: t('低危'), class: 'leak-low', icon: <Image src={leakLow} width={19} /> },
    1: { label: t('中危'), class: 'leak-center', icon: <Image src={leakCenter} width={19} /> },
    2: { label: t('高危'), class: 'leak-high', icon: <Image src={leakHigh} width={19} /> },
    3: { label: t('严重'), class: 'leak-severity', icon: <Image src={leakSeverity} width={19} /> },
  }

  const interceptStatusMap = {
    intercept_status_intercept_success: { label: t('拦截成功'), class: 'intercept-success' },
    intercept_status_detect_success: { label: t('检测成功'), class: 'detection-success' },
    intercept_status_intercept_defence_fail: { label: t('防护失效'), class: 'intercept-fail' },
  }

  const resourceLevelMap = {
    resource_level_low: { label: t('初级'), class: 'case-level-low' },
    resource_level_middle: { label: t('中级'), class: 'case-level-center' },
    resource_level_high: { label: t('高级'), class: 'case-level-high' },
  }

  const logAlarmMap = {
    1: { label: t('有告警'), class: 'log-alarm-success' },
    0: { label: t('无告警'), class: 'log-alarm-fail' },
  }

  const resourceTypeMap = {
    '7': { label: 'URL', class: 'resource-type-url' },
    '8': { label: t('附件'), class: 'resource-type-attach' },
  }

  const attachmentType = [
    { id: '101', name: t('勒索病毒') },
    { id: '102', name: t('恶意软件') },
    { id: '103', name: t('蠕虫') },
    { id: '104', name: 'Payload' },
    { id: '105', name: 'EXP' },
    { id: '106', name: t('挖矿') },
  ]

  const attachList = [
    { id: '1', name: t('office文档') },
    { id: '2', name: t('脚本文件') },
    { id: '3', name: t('PE可执行文件') },
    { id: '4', name: t('可执行与可链接格式') },
    { id: '5', name: t('日历文件') },
    { id: '6', name: t('网页文件') },
    { id: '7', name: t('压缩文件') },
  ]

  const totalTypeList = useMemo(
    () => uniqBy(attackTypeList?.concat(attachmentType), 'id'),
    [attackTypeList],
  )

  const attackTypeMap = totalTypeList.map(item => [item.id, item.name])

  const cascaderOptions = useMemo(
    () =>
      attckCascaderData.map(stage => ({
        value: stage.id,
        label: stage.name,
        children: stage.technology.map(tech => ({
          value: tech.id,
          label: tech.name,
          children: tech.subTechnology
            .filter(subTech => subTech.id !== '0')
            .map(subTech => ({
              value: subTech.id,
              label: subTech.name,
            })),
        })),
      })),
    [attckCascaderData],
  )

  const options = [
    {
      label: t('用例名称'),
      value: 'case_name',
      type: 'input' as const,
    },
    {
      label: 'ATT&CK',
      value: 'attck_id',
      type: 'cascader',
      mode: 'multiple',
      options: cascaderOptions,
    },
    {
      label: t('用例标签'),
      value: 'tag_ids',
      type: 'treeSelect',
      mode: 'multiple',
      options: TagSearchOption(tagTreeOptions),
    },
    {
      label: t('模板名称'),
      value: 'template_id_list',
      type: 'select',
      mode: 'multiple',
      options:
        taskInfo?.template_list?.map(item => ({
          label: item?.template_name,
          value: item?.template_id,
        })) || [],
    },
    {
      label: t('模板类型'),
      value: 'resource_type_list',
      mode: 'multiple',
      type: 'select',
      options: [
        { value: '8', label: t('附件模板') },
        { value: '7', label: t('URL模板') },
      ],
    },
    {
      label: t('附件类型'),
      value: 'attachment_type_list',
      type: 'select',
      mode: 'multiple',
      options: attachList.map(item => ({
        label: item.name,
        value: item.id,
      })),
    },
    {
      label: t('攻击组织'),
      value: 'apt_name_list',
      type: 'select',
      mode: 'multiple',
      options: aptList.map(item => ({
        label: item,
        value: item,
      })),
    },
  ]

  const columns = [
    {
      title: t('用例名称'),
      dataIndex: 'case_name',
      key: 'case_name',
      width: '30%',
      render: (_, record: any) => (
        <Text
          ellipsis={{
            tooltip: {
              getPopupContainer: () => document.body,
            },
          }}
          className="case_name"
          style={{ width: 300, cursor: 'pointer' }}
          onClick={() => {
            console.log('record', record)
            getDrawerData(record)
          }}
        >
          {record?.case_name}
        </Text>
      ),
    },
    {
      title: '危险等级',
      dataIndex: 'risk_level',
      key: 'risk_level',
      width: '10%',
      filteredValue: filterParams.risk_level,
      render: (_, record: any) => (
        <div>
          {riskLevelMap[record?.risk_level - 1]?.icon}
          <span className={riskLevelMap[record?.risk_level - 1]?.class}>
            {riskLevelMap[record?.risk_level - 1]?.label}
          </span>
        </div>
      ),
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择危险等级')}
            value={props.selectedKeys as string[]}
            open={riskLevelSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            popupClassName="table-filter-dropdown"
            onDropdownVisibleChange={setRiskLevelSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setRiskLevelSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={[
              { label: t('严重'), value: '4' },
              { label: t('高危'), value: '3' },
              { label: t('中危'), value: '2' },
              { label: t('低危'), value: '1' },
            ]}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),
    },
    {
      title: t('攻击类型'),
      dataIndex: 'attack_type_list',
      key: 'attack_type_list',
      width: '10%',
      filteredValue: filterParams.attack_type_list,
      render: (_, { attack_type }) => (
        <Text
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
          style={{ width: 140 }}
        >
          <TableTag color={'#677280'} background="#EBEFF2" style={{ padding: '1px 4px' }}>
            {new Map(attackTypeMap).get(String(attack_type)) || '-'}
          </TableTag>
        </Text>
      ),
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择攻击类型')}
            value={props.selectedKeys as string[]}
            open={attackTypeSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            popupClassName="table-filter-dropdown"
            onDropdownVisibleChange={setAttackTypeSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setAttackTypeSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={totalTypeList.map(item => ({ label: item.name, value: String(item.id) }))}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),
    },
    {
      title: t('用例分级'),
      dataIndex: 'resource_level',
      key: 'resource_level',
      width: '7%',
      filteredValue: filterParams.resource_level,
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择用例分级')}
            value={props.selectedKeys as string[]}
            open={resourceLevelSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            popupClassName="table-filter-dropdown"
            onDropdownVisibleChange={setResourceLevelSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setResourceLevelSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={[
              { label: t('初级'), value: '1' },
              { label: t('中级'), value: '2' },
              { label: t('高级'), value: '3' },
            ]}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),
      render: (_, record: any) => (
        <div>
          <span>{resourceLevelMap[record?.resource_level]?.label || '-'}</span>
        </div>
      ),
    },
    {
      title: t('验证结果'),
      dataIndex: 'intercept_status',
      key: 'intercept_status',
      width: '10%',
      filteredValue: filterParams.intercept_status,
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择验证结果')}
            value={props.selectedKeys as string[]}
            open={interceptStatusSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            dropdownClassName="table-filter-dropdown"
            onDropdownVisibleChange={setInterceptStatusSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setInterceptStatusSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={[
              { label: t('拦截成功'), value: '1' },
              { label: t('检测成功'), value: '3' },
              { label: t('防护失效'), value: '2' },
            ]}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),
      render: (_, record: any) => (
        <div>
          <span className={interceptStatusMap[record?.intercept_status]?.class}>
            {interceptStatusMap[record?.intercept_status]?.label || '-'}
          </span>
        </div>
      ),
    },
    ...(taskInfo?.devices?.length > 0
      ? [
          {
            title: t('设备结果分布'),
            dataIndex: 'device_status_list',
            key: 'device_status_list',
            width: '12%',
            filteredValue: filterParams.device_status_list,
            filterDropdown: (props: FilterDropdownProps) => (
              <div style={{ padding: 8, width: 300 }}>
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  maxTagCount={'responsive'}
                  style={{ width: '100%' }}
                  placeholder={t('请选择设备结果')}
                  value={props.selectedKeys as string[]}
                  open={deviceStatusSelectOpen}
                  getPopupContainer={() => document.body as HTMLElement}
                  popupClassName="table-filter-dropdown"
                  onDropdownVisibleChange={setDeviceStatusSelectOpen}
                  onChange={value => {
                    props.setSelectedKeys(value)
                  }}
                  dropdownRender={menu => (
                    <div style={{ marginBottom: '6px' }}>
                      {menu}
                      <Divider style={{ margin: '3px 0 6px 0' }} />
                      <Space
                        className="space-btn"
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          type="default"
                          size="small"
                          style={{ letterSpacing: '-2px', padding: '0 12px' }}
                          onClick={() => {
                            props.clearFilters?.()
                          }}
                        >
                          {t('重置')}
                        </Button>
                        <Button
                          type="primary"
                          size="small"
                          style={{ letterSpacing: '-2px', padding: '0 12px' }}
                          onClick={() => {
                            props.confirm()
                            setDeviceStatusSelectOpen(false)
                          }}
                        >
                          {t('确定')}
                        </Button>
                      </Space>
                    </div>
                  )}
                  options={[
                    { value: 'ResourceDeviceStatusDetectSuccess', label: t('检测成功') },
                    { value: 'ResourceDeviceStatusInterceptSuccess', label: t('拦截成功') },
                    { value: 'ResourceDeviceStatusProtectionInvalid', label: t('防护失效') },
                    { value: 'ResourceDeviceStatusNotInvolved', label: t('不涉及') },
                  ]}
                />
              </div>
            ),
            filterIcon: (filtered: boolean) => (
              <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
                <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
              </Tooltip>
            ),
            render: (_, record: any) => {
              const totalCount =
                Number(record?.detection_success_count) +
                Number(record?.intercept_success_count) +
                Number(record?.protection_invalid_count) +
                Number(record?.not_involved_count)
              if (totalCount === 1) {
                if (record?.detection_success_count === '1') {
                  return <span>{t('检测成功')}</span>
                } else if (record?.intercept_success_count === '1') {
                  return <span>{t('拦截成功')}</span>
                } else if (record?.protection_invalid_count === '1') {
                  return <span>{t('防护失效')}</span>
                } else if (record?.not_involved_count === '1') {
                  return <span>{t('不涉及')}</span>
                }
              } else if (totalCount === 0) {
                return '-'
              } else {
                return (
                  <div>
                    <>
                      <Tooltip title={`${t('检测成功')}${record?.detection_success_count}`}>
                        <span style={{ color: '#72B851' }}>{record?.detection_success_count}</span>
                      </Tooltip>
                      <span style={{ margin: '0 4px' }}>|</span>
                    </>

                    <>
                      <Tooltip title={`${t('拦截成功')}${record?.intercept_success_count}`}>
                        <span style={{ color: '#5677D9' }}>{record?.intercept_success_count}</span>
                      </Tooltip>
                      <span style={{ margin: '0 4px' }}>|</span>
                    </>

                    <>
                      <Tooltip title={`${t('防护失效')}${record?.protection_invalid_count}`}>
                        <span style={{ color: '#F44F4F' }}>{record?.protection_invalid_count}</span>
                      </Tooltip>
                      <span style={{ margin: '0 4px' }}>|</span>
                    </>

                    <>
                      <Tooltip title={`${t('不涉及')}${record?.not_involved_count}`}>
                        <span style={{ color: '#333333' }}>{record?.not_involved_count}</span>
                      </Tooltip>
                    </>
                  </div>
                )
              }
            },
          },
        ]
      : []),
    {
      title: t('告警结果'),
      dataIndex: 'alarm',
      key: 'alarm',
      width: '10%',
      render: (_, record: any) => (
        <div>
          <span className={record?.alarm ? 'log-alarm-success' : 'log-alarm-fail'}>
            {record?.alarm ? t('有告警') : t('无告警')}
          </span>
        </div>
      ),
    },
    {
      title: t('执行时间'),
      dataIndex: 'sort_field_exec_time',
      key: 'sort_field_exec_time',
      width: '14%',
      sorter: (a, b) => a.exec_time - b.exec_time,
      render: (_, record: any) => (
        <Tooltip
          title={record.exec_time ? record.exec_time : '-'}
          getPopupContainer={() => document.body}
        >
          {record.exec_time ? formatDateTime(record.exec_time, 'mdhm') : '-'}
        </Tooltip>
      ),
    },
    {
      title: t('操作'),
      fixed: 'right',
      width: '10%',
      render: (_, record: any) => (
        <div
          className="operation"
          onClick={() => {
            getDrawerData(record)
          }}
        >
          <IconFont type="icon-chakan" />
          <span>{t('查看')}</span>
        </div>
      ),
    },
  ]

  const rowSelection = {
    selectedRowKeys,
    onSelect: (record, selected) => {
      let newSelectedRowKeys = [...selectedRowKeys]
      if (selected) {
        newSelectedRowKeys.push(record.id)
      } else {
        newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== record.id)
      }
      setSelectedRowKeys(newSelectedRowKeys)
    },
    onSelectAll: selected => {
      const newSelectedRowKeys = selected ? useCaseList.map(item => item.id) : []
      setSelectedRowKeys(newSelectedRowKeys)
    },
  }

  const getDrawerData = item => {
    setDetailDrawerVisible(true)
    setResourceType(item.resource_type)
    getResultResourceDetail({
      resource_type: item.resource_type,
      id: item.id,
    })
      .then(res => {
        setPluginDetail(res?.data)
      })
      .catch(_ => {})
  }

  const handleToggleTime = (timeId: string) => {
    setTimeId(timeId)
    getEchartsData(timeId)
    refreshRequest(timeId)
  }

  // 返回上一页
  const handleBack = () => {
    navigate('/validation/network/emailgateway?tab=task')
  }

  // 删除日志设备导入记录
  const deleteRecord = (importRecordId: string) => {
    deleteOfflineLogInfo({ resultId: id, id: importRecordId })
      .then(() => {
        refreshRequest()
        getEchartsData()
        setRandom(Math.random())
      })
      .catch(_ => {})
  }

  // 创建报表
  const createReport = values => {
    generateReport({
      task_list: [{ task_name: reportVisible.name, campaign_id: id }],
      ...values,
    })
      .then(() => {
        window.open('/report/task/task-report?tab=3', '_self')
      })
      .catch(_ => {})
  }

  // 删除任务
  const handleDelete = async () => {
    try {
      if (id) {
        await deleteTask({ result_id_list: [id] })
        navigate('/validation/network/emailgateway?tab=task')
      }
    } catch (error) {}
  }

  const handleExpand = () => {
    getFailPluginLog({ result_id: id }).then(res => {
      const content = res?.data?.items?.map(item => ({
        key: item.id,
        label: item.resource_name,
        children: item.failed_reason,
      }))
      setFailLogInfo(origin => ({ ...origin, content }))
    })
    getExecuteInfo({ resultId: id }).then(res => {
      setFailedCaseList(res?.data?.sentFailCaseList)
      setUnsentCaseList(res?.data?.unsentCaseList)
      setProgressContentList(res?.data?.sentFailCaseList?.caseInfo || [])
    })
  }

  const handleFixed = values => {
    setFixedModalVisible(false)
    const { interceptStatus } = values
    console.log('interceptStatus', interceptStatus)

    updateResourceInterceptStatus({
      id: id,
      taskResultResourceList: selectedRowKeys.map(key => ({
        resourceId: key,
        interceptStatus,
      })),
    })
      .then(_ => {
        setRandom(new Date().getTime())
        form.resetFields()
        setSelectedRowKeys([])
        const processedParams = processFilterParams(filterParams)
        getUseCaseList({ result_id: id, ...processedParams })
          .then(res => {
            setUseCaseList(res.data.items)
            setUseCaseTotal(res.data.filter_total)
            setFixPayloadCount(res.data.manual_correct_count)
          })
          .catch(() => {})
      })
      .catch(_ => {})
  }

  // 处理筛选参数，移除标识符
  const processFilterParams = (params: any) => {
    const processedParams = { ...params }
    const keyMapping = {
      tree_resource_level: 'resource_level',
      tree_risk_level: 'risk_level',
      tree_intercept_status: 'intercept_status',
      tree_device_ids: 'device_ids',
    }

    Object.keys(processedParams).forEach(key => {
      if (keyMapping[key]) {
        processedParams[keyMapping[key]] = processedParams[key]
        delete processedParams[key]
      }
    })

    return processedParams
  }

  const onTableChange = (pagination: any, filters: any, sorter: any) => {
    console.log('pagination', pagination)
    console.log('filters', filters)
    console.log('sorter', sorter)
    setFilterParams(prev => {
      // 保留之前的筛选条件，只更新发生变化的筛选条件
      const newFilters = { ...prev }

      // 处理表头筛选条件
      Object.keys(filters).forEach(key => {
        if (filters[key] === null) {
          delete newFilters[key]
        } else {
          newFilters[key] = filters[key]
        }
      })

      // 保留filterFormValue的筛选条件
      if (filterFormValue?.field && filterFormValue?.value) {
        const processedValue =
          filterFormValue.field === 'tag_ids'
            ? (filterFormValue.value as string[])?.map(item => item.split('$').slice(1).join('$'))
            : filterFormValue.value
        newFilters[filterFormValue.field] = processedValue
      }

      return {
        ...newFilters,
        page: pagination.current,
        limit: pagination.pageSize,
        sortOrder:
          sorter.order === 'descend'
            ? 'SORT_ORDER_DESCENDING'
            : sorter.order === 'ascend'
            ? 'SORT_ORDER_ASCENDING'
            : undefined,
        sortField: sorter.order === undefined ? undefined : sorter.field,
      }
    })
  }

  const handleChecked = (e, cardId) => {
    let newSelectedRowKeys = [...selectedRowKeys]
    const selectedkey = e[0]
    if (!selectedkey) {
      newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== cardId)
    } else {
      if (newSelectedRowKeys.includes(selectedkey)) {
        newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== selectedkey)
      } else {
        newSelectedRowKeys.push(selectedkey)
      }
    }
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const handleActive = (e, item) => {
    if (e.target.className === 'ant-checkbox-input') return
    getDrawerData(item)
    setCardActive(item.id)
  }

  const tagTreeData = useMemo(() => {
    const listMappings = [
      {
        title: t('用例分级'),
        list: subTaskFilterData?.caseLevelList || [],
        total: subTaskFilterData?.caseLevelTotal || 0,
        key: 'tree_resource_level',
      },
      {
        title: t('危险等级'),
        list: subTaskFilterData?.riskLevelList || [],
        total: subTaskFilterData?.riskLevelTotal || 0,
        key: 'tree_risk_level',
      },
      {
        title: t('验证结果'),
        list: subTaskFilterData?.resourceStatusList || [],
        total: subTaskFilterData?.resourceStatusTotal || 0,
        key: 'tree_intercept_status',
      },
      {
        title: t('安全设备'),
        list: subTaskFilterData?.deviceList || [],
        total: subTaskFilterData?.deviceTotal || 0,
        key: 'tree_device_ids',
      },
    ]
    return listMappings.map(category => ({
      title: category.title,
      key: category.key,
      extra: category.total,
      children: category.list.map(item => ({
        title: item.fieldName,
        key: `${category.key}_${item.fieldId}`,
        extra: item.resourceCount,
      })),
    }))
  }, [subTaskFilterData])

  const getEchartsData = (result_id: string | undefined = id) => {
    getDeviceProtectionList({ resultId: result_id }).catch(_ => {})
    getTaskScore({ resultId: result_id }).catch(_ => {})
    getVerifyDistribution({ resultId: result_id }).catch(_ => {})
    getAttackDefenseRanking({ resultId: result_id }).catch(_ => {})
    getAttachmentTypeRanking({ resultId: result_id }).catch(_ => {})
    getRiskLevelDistribution({ resultId: result_id }).catch(_ => {})
    getResourceLevelsRanking({ resultId: result_id }).catch(_ => {})
    getTemplateLoseEfficacyRanking({ resultId: result_id }).catch(_ => {})
  }

  const refreshRequest = (result_id = id) => {
    getTaskInfo({ resultId: result_id, taskId: task_id, userId }).catch(_ => {})
    getAttckCascaderData({ resultId: id || '', taskId: task_id }).catch(() => {})
    getAttackTypeList().catch(() => {})
    getTagTreeOptions({ result_id: id }).catch(_ => {})
    getSubTaskFilterData({ resultId: id }).catch(_ => {})
    getAPTList({ resultId: id }).catch(_ => {})
    getOfflineLogInfo(result_id).catch(_ => {})
    setRandom(new Date().getTime())
    setFilterParams({ page: 1, limit: 20 })

    getExecuteInfo({ resultId: id }).then(res => {
      setFailedCaseList(res?.data?.sentFailCaseList)
      setUnsentCaseList(res?.data?.unsentCaseList)
      setProgressContentList(res?.data?.sentFailCaseList?.caseInfo || [])
    })
  }

  const progressInfo = useMemo(
    () => ({
      ...taskInfo,
    }),
    [taskInfo],
  )

  useEffect(() => {
    getTaskInfo({ resultId: id, taskId: task_id, userId }).catch(_ => {})
    getOfflineLogInfo(id).catch(_ => {})
    getAttckCascaderData({ result_id: id || '', task_id: task_id }).catch(() => {})
    getAttackTypeList().catch(() => {})
    getTagTreeOptions({ result_id: id }).catch(_ => {})
    getSubTaskFilterData({ resultId: id }).catch(_ => {})
    getAPTList({ resultId: id }).catch(_ => {})
  }, [])

  // 下拉筛选
  useEffect(() => {
    if (filterFormValue?.field) {
      const selectedOption = options.find(opt => opt.value === filterFormValue.field)
      if (selectedOption) {
        const processedValue =
          filterFormValue?.field === 'tag_ids'
            ? filterFormValue?.value === ''
              ? null
              : (filterFormValue?.value as string[])?.map(item =>
                  item.split('$').slice(1).join('$'),
                )
            : filterFormValue?.field === 'attck_id'
            ? (
                filterFormValue?.value as unknown as Array<{
                  tacticId: string
                  technologyId: string
                  subTechnologyId: string
                }>
              )?.map(item => ({
                tactic_id: item.tacticId,
                technology_id: item.technologyId,
                sub_technology_id: item.subTechnologyId,
              }))
            : filterFormValue?.value
        setFilterParams(prev => {
          // 检查当前字段的值是否真的发生了变化
          if (prev[filterFormValue.field] === processedValue) {
            return prev
          }
          const dropdownKeys = options.map(opt => opt.value)
          const updatedParams = {
            ...prev,
            page: 1,
            [filterFormValue.field]: processedValue,
          }
          // 清除其他下拉筛选条件
          dropdownKeys.forEach(key => {
            if (key !== filterFormValue.field && key in updatedParams) {
              delete updatedParams[key]
            }
          })
          return updatedParams
        })
      }
    }
  }, [filterFormValue])
  useEffect(() => {
    const processedParams = processFilterParams(filterParams)
    console.log('processedParams', processedParams)
    getUseCaseList({ result_id: id, ...processedParams })
      .then(res => {
        setUseCaseList(res.data.items)
        setUseCaseTotal(res.data.filter_total)
        setFixPayloadCount(res.data.manual_correct_count)
      })
      .catch(_ => {})
  }, [filterParams])

  useEffect(() => {
    let intervalId
    if (importRecord.importing) {
      intervalId = setInterval(() => {
        getOfflineLogInfo(id)
          .then(res => {
            if (!res.data.importing) {
              refreshRequest()
              getEchartsData()
              setRandom(new Date().getTime())
            }
          })
          .catch(_ => {})
      }, 3000)
    }

    return () => clearInterval(intervalId)
  }, [importRecord])

  const statusMap = {
    2: { label: t('进行中'), color: '#2973FF', background: '#DBE8FF' },
    3: { label: t('已完成'), color: '#67c23a', background: '#E4F7D1' },
    4: { label: t('中断'), color: '#F53F3F', background: '#FFDCE0' },
    7: { label: t('停止中'), color: '#FF9900', background: '#FFEFD7' },
  }

  const fixedOptions = useMemo(
    () =>
      taskInfo?.devices?.length > 0
        ? [
            { label: t('拦截成功'), value: 'intercept_status_intercept_success' },
            { label: t('防护失效'), value: 'intercept_status_intercept_defence_fail' },
            { label: t('检测成功'), value: 'intercept_status_detect_success' },
          ]
        : [
            { label: t('拦截成功'), value: 'intercept_status_intercept_success' },
            { label: t('防护失效'), value: 'intercept_status_intercept_defence_fail' },
          ],
    [taskInfo],
  )

  const taskContent = (
    <TaskContent>
      {taskInfoModel.map((item, index) => {
        const value =
          item.type && item.type !== 'array' && item.type !== 'object'
            ? taskInfo[item.value as string]
            : item.value
        if (value && typeof value === 'object') {
          // 处理进度信息渲染
          return (
            <div key={index} className="progress-info">
              <span className="label">{item.key}：</span>
              {value.map((v, i) => {
                if (v.value === 'progress_rate') {
                  return (
                    <Progress
                      key={i}
                      strokeColor={{
                        '0%': '#dfe7f9',
                        '100%': '#0346F2',
                      }}
                      success={{ percent: -1 }}
                      percent={taskInfo[v.value as string]}
                    />
                  )
                } else {
                  return (
                    <div
                      key={i}
                      className={v.value}
                      style={
                        v.value === 'is_finished'
                          ? {
                              background: statusMap[taskInfo?.[v.value as number]]?.background,
                              color: statusMap[taskInfo?.[v.value as number]]?.color,
                            }
                          : {}
                      }
                    >
                      {v.value === 'send_success_sum' ? (
                        <Tooltip title={t('发送成功用例数量')}>
                          <span>{taskInfo?.[v.value as string] || '0'}</span>
                        </Tooltip>
                      ) : v.value === 'send_fail_sum' ? (
                        <Tooltip title={t('发送失败用例数量')}>
                          <span>{taskInfo?.[v.value as string] || '0'}</span>
                        </Tooltip>
                      ) : (
                        <span>
                          {v.value === 'is_finished'
                            ? statusMap[taskInfo?.[v.value as number]]?.label
                            : taskInfo?.[v.value as string] || '0'}
                        </span>
                      )}
                      {v.value === 'send_success_sum' && (
                        <span style={{ color: '#666', margin: '0 4px' }}>/</span>
                      )}
                    </div>
                  )
                }
              })}
            </div>
          )
        } else {
          return (
            <div key={index}>
              <span className="label">{item.key}：</span>
              <span>{value}</span>
              <Divider type="vertical" />
            </div>
          )
        }
      })}
    </TaskContent>
  )

  const taskContentExpanded = (
    <TaskContentExpanded>
      {/* 任务信息 */}
      <div className="task-info">
        <div className="sub-title">
          <div>
            <SvgIcon width={16} height={16} name={'data-arrival'} fill={'#fff'} />
            <span className="text">{t('任务信息')}</span>
          </div>
          {taskInfo?.scheduler_type !== 'TaskKindDetailImmediately' && (
            <div style={{ fontSize: 13, fontWeight: 400, display: 'flex', alignItems: 'center' }}>
              <div>{t('执行日期：')} </div>
              <Select
                getPopupContainer={node => node?.parentNode?.parentNode}
                style={{ width: 180, marginRight: 10 }}
                value={executeTimeId}
                onChange={timeId => {
                  handleToggleTime(timeId)
                }}
              >
                {taskInfo?.task_time_list?.map((item, index) => (
                  <Select.Option key={index} value={item.result_id}>
                    {item.task_time}
                  </Select.Option>
                ))}
              </Select>
            </div>
          )}
        </div>
        <div className="tab-box">
          <div className="left">
            <div className="tab-item active">
              <span>{t('验证模式1')}</span>
            </div>
          </div>
          <div className="right">
            <div
              className={`tab-item ${infoActiveTab === 'taskTemplate' ? 'active' : ''}`}
              onClick={() => {
                setInfoActiveTab('taskTemplate')
              }}
            >
              <span>{t('任务模板')}</span>
            </div>
            <div
              className={`tab-item ${infoActiveTab === 'securityDevice' ? 'active' : ''}`}
              onClick={() => {
                setInfoActiveTab('securityDevice')
              }}
            >
              <span>{t('安全设备')}</span>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="left">
            {taskInfoExpanded.slice(0, taskInfoExpanded.length - 2).map((item, index) => {
              const value =
                item.type && item.type !== 'array' && item.type !== 'object'
                  ? taskInfo[item.value as string]
                  : item.value
              if (value && typeof value === 'object') {
                // 处理执行类型渲染
                if (
                  taskInfo.scheduler_type === 'TaskKindDetailImmediately' ||
                  taskInfo.scheduler_type === 'TaskKindDetailBooking'
                ) {
                  // 普通任务（立即执行）
                  return (
                    <div className="left-item" key={index}>
                      <span className="label">{item.key}：</span>
                      <span style={{ marginRight: 8 }}>
                        {taskInfo.scheduler_type === 'TaskKindDetailImmediately'
                          ? t('立即')
                          : t('预定')}
                      </span>
                      <span>
                        {taskInfo?.task_time_list &&
                          taskInfo?.task_time_list.length > 0 &&
                          taskInfo?.task_time_list.find(v => v.result_id === id)?.task_time}
                      </span>
                    </div>
                  )
                } else {
                  // 定时任务
                  return (
                    <div className="left-item" key={index}>
                      <span className="label">{item.key}：</span>
                      {taskInfo?.scheduler_type === 'TaskKindDetailImmediately' && (
                        <span className="type-text">{t('立即')}</span>
                      )}
                      {taskInfo?.scheduler_type === 'TaskKindDetailBooking' && (
                        <span className="type-text">{t('预定')}</span>
                      )}
                      {taskInfo?.scheduler_type === 'TaskKindDetailCycleDay' && (
                        <span className="type-text">{t('每日')}</span>
                      )}
                      {taskInfo?.scheduler_type === 'TaskKindDetailCycleWeek' && (
                        <span className="type-text">{t('每周')}</span>
                      )}
                      {taskInfo?.scheduler_type === 'TaskKindDetailCycleMonth' && (
                        <span className="type-text">{t('每月')}</span>
                      )}
                      {taskInfo?.scheduler_type !== 'TaskKindDetailImmediately' &&
                        taskInfo?.scheduler_type !== 'TaskKindDetailBooking' && (
                          <Select
                            className="type-select"
                            placeholder={t('点击查看')}
                            size="small"
                            style={{ width: 180 }}
                          >
                            {taskInfo?.scheduler_time_list?.map((v, i) => (
                              <Select.Option key={i} value={v}>
                                {v}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                    </div>
                  )
                }
              } else if (item.key === t('发送间隔')) {
                return (
                  <div key={index} className="left-item">
                    <span className="label">{item.key}：</span>
                    <span>{`${taskInfo.exec_rate} ${t('秒')}`}</span>
                  </div>
                )
              } else {
                return (
                  <div key={index} className="left-item">
                    <span className="label">{item.key}：</span>
                    <span>
                      {item.key === t('模式名称') ? (
                        `${taskInfo.attack_source} → ${taskInfo.attack_target}`
                      ) : (
                        <Tooltip title={value || ''} placement="topLeft">
                          <span
                            style={{
                              width: 'calc(100% - 85px - 12px)',
                              minWidth: '190px',
                              display: 'inline-block',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {value || '-'}
                          </span>
                        </Tooltip>
                      )}
                    </span>
                  </div>
                )
              }
            })}
          </div>
          <div className="right">
            {infoActiveTab === 'taskTemplate' &&
              taskInfoExpanded
                .slice(taskInfoExpanded.length - 2, taskInfoExpanded.length - 1)
                .map((item, index) => (
                  <div className="tab-content">
                    {taskInfo[item.value as string]?.length > 0 ? (
                      taskInfo[item.value as string].map((v, i) => (
                        <Text key={i} className="template" ellipsis={{ tooltip: true }}>
                          {v.template_name}
                        </Text>
                      ))
                    ) : (
                      <Empty image={EmptyImg} />
                    )}
                  </div>
                ))}
            {infoActiveTab === 'securityDevice' &&
              taskInfoExpanded
                .slice(taskInfoExpanded.length - 1, taskInfoExpanded.length)
                .map((item, index) => (
                  <div className="tab-content">
                    {taskInfo[item.value as string]?.length > 0 ? (
                      taskInfo[item.value as string].map((v, i) => (
                        <Text key={i} className="template" ellipsis={{ tooltip: true }}>
                          {typeof v === 'object'
                            ? `${v.device_type}-${v.device_name}-${v.device_ip}`
                            : v}
                        </Text>
                      ))
                    ) : (
                      <Empty image={EmptyImg} />
                    )}
                  </div>
                ))}
          </div>
        </div>
      </div>
      {/* 进度信息 */}
      <div className="progress-info">
        {/* payload 列表 */}
        <div style={{ display: !logInfo.visible && !failLogInfo.visible ? 'block' : 'none' }}>
          <div className="sub-title">
            <div className="left">
              <SvgIcon
                width={16}
                height={16}
                name={'task-detail-schedule'}
                fill={'#fff'}
                style={{ marginTop: '5px' }}
              />
              <span className="text" style={{ width: 65 }}>
                {t('执行信息')}
              </span>
            </div>
            <div className="create-time">
              <span>
                {t('执行时间：')}
                <span>{progressInfo?.create_time}</span>
                <span style={{ margin: '0 4px' }}>{t('至')}</span>
                <span>{progressInfo?.end_time || '-'}</span>
              </span>
              <span style={{ marginLeft: 10 }}>
                {t('时长：')}
                <span style={{ marginLeft: 5 }}>
                  {t('共')}
                  {formatTimeInterval(progressInfo?.create_time, progressInfo?.end_time)}
                </span>
              </span>
            </div>
          </div>
          <div
            style={{ display: 'flex', alignItems: 'center', margin: '15px 0', padding: '0 12px' }}
          >
            <div
              className="status"
              style={{
                background: statusMap[progressInfo.is_finished]?.background,
                color: statusMap[progressInfo.is_finished]?.color,
              }}
            >
              <span>{statusMap[progressInfo.is_finished]?.label}</span>
            </div>
            <Progress
              className="progress"
              strokeColor={{
                '0%': '#ECEBF9',
                '100%': '#5047CC',
              }}
              success={{ percent: -1 }}
              percent={progressInfo?.progress_rate}
            />
          </div>
          <div className="execute-box">
            <div className="execute-tab-box">
              <div className="execute-item-title">
                <div
                  className={
                    activeTab === 'failed'
                      ? 'execute-item-title-text active'
                      : 'execute-item-title-text'
                  }
                  onClick={() => {
                    setActiveTab('failed')
                    setProgressContentList(failedCaseList?.caseInfo)
                  }}
                >
                  {t('发送失败')}（{failedCaseList?.total || 0}）
                </div>
                <div
                  className={
                    activeTab === 'unexecuted'
                      ? 'execute-item-title-text active'
                      : 'execute-item-title-text'
                  }
                  onClick={() => {
                    setActiveTab('unexecuted')
                    setProgressContentList(unsentCaseList?.caseInfo)
                  }}
                >
                  {t('未发送')}（{unsentCaseList?.total || 0}）
                </div>
              </div>
              <div className="execute-success-box">
                <span>{t('发送成功：')}</span>
                <span className="success-sum">{progressInfo?.send_success_sum}</span>
                <span>{t('个')}</span>
              </div>
            </div>
            <div className="execute-tab-content">
              <ProgressContent
                setLogInfo={setLogInfo}
                type={activeTab === 'failed' ? 1 : 2}
                contentList={progressContentList}
              />
            </div>
          </div>
        </div>
        {/* payload 日志 */}
        <div style={{ display: logInfo.visible ? 'block' : 'none' }}>
          <div className="sub-title">
            <div className="left">
              <Button
                className="return-btn"
                icon={<IconFont type="icon-fanhui2" className="return-icon" />}
                onClick={() =>
                  setLogInfo(origin => ({ ...origin, visible: false, content: '', id: '' }))
                }
              />
              <span className="text">{t('执行日志：')}</span>
            </div>
          </div>
          <div className="log-content">
            <div className="log-panel">
              <div className="content">
                {logInfo.content && <div className="log-content">{logInfo.content}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </TaskContentExpanded>
  )

  const cardItem = item => (
    <div
      className={cardActive === item.id ? 'card-item active' : 'card-item'}
      key={item.id}
      onClick={e => handleActive(e, item)}
    >
      <div className="top">
        <Form form={form}>
          <Item noStyle name={item.id}>
            <Group
              options={[{ label: undefined, value: item.id }]}
              onChange={e => handleChecked(e, item.id)}
            />
          </Item>
        </Form>
        <Text
          style={{ width: '210px', marginLeft: '8px' }}
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
        >
          {item.case_name}
        </Text>
      </div>
      <div className="bottom">
        <div className="left">
          <SvgIcon
            name={item?.intercept_status === 1 ? 'protection_succeeded' : 'protection_failed'}
            width={'40px'}
            height={'44px'}
          />
        </div>
        <div className="right">
          <div
            className={
              item.intercept_status === 1
                ? 'intercept-status success'
                : item.intercept_status === 2
                ? 'intercept-status failed'
                : 'intercept-status cancel'
            }
          >
            {interceptStatusMap[item.intercept_status].label}
          </div>
          <div className="icons">
            <div className={riskLevelMap[item.risk_level - 1]?.class}>
              {riskLevelMap[item.risk_level - 1]?.icon}
              <span>{riskLevelMap[item.risk_level - 1]?.label}</span>
            </div>
            <div className={resourceTypeMap[item.resource_type]?.class}>
              <span>{resourceTypeMap[item.resource_type]?.label}</span>
            </div>
            <Text className="attack-type">
              {new Map(attackTypeMap).get(item.attack_type) || ''}
            </Text>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <DetailContainer>
      <DetailTemplate
        scene={displayModel.name}
        taskName={taskInfo.task_name}
        taskStatus={taskInfo.is_finished ? Number(taskInfo.is_finished) : 0}
        isImporting={importRecord.importing}
        canImport={importRecord.canImport}
        taskContent={taskContent}
        taskContentExpanded={taskContentExpanded}
        onTableChange={onTableChange}
        taskCharts={
          <TaskCharts
            status={taskInfo.is_finished}
            attackTypeList={attackTypeList}
            taskScore={taskScore}
            verifyResult={verifyDistribution}
            attackProtectionRanking={attackDefenseRanking}
            attachmentTypeRanking={attachmentTypeRanking}
            deviceProtectionRanking={deviceProtectionList}
            templateProtectionFailureRanking={templateLoseEfficacyRanking}
            riskLevelDistribution={riskLevelDistribution}
            caseLevelDistribution={resourceLevelsRanking}
          />
        }
        treeData={tagTreeData}
        cardItem={cardItem}
        handleExpand={handleExpand}
        filterOptions={options}
        filterFormValue={filterFormValue}
        setFilterFormValue={setFilterFormValue}
        filterParams={filterParams}
        setFilterParams={setFilterParams}
        columns={columns}
        scroll={{ x: 1300 }}
        dataSource={useCaseList}
        total={useCaseTotal}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        rowSelection={rowSelection}
        fixedCount={fixPayloadCount}
        fixedOptions={fixedOptions}
        handleFixed={handleFixed}
        fixedLoading={updateInterceptStatusLoading}
        getEchartsData={getEchartsData}
        refreshRequest={refreshRequest}
        loading={useCaseListLoading}
        handleBack={handleBack}
        openRecordModal={setRecordVisible}
        openImportModal={setImportVisible}
        openReportModal={setReportVisible}
        openDeleteModal={setDeleteVisible}
        fixedModalVisible={fixedModalVisible}
        setFixedModalVisible={setFixedModalVisible}
      />

      <RecordModal
        open={recordVisible}
        loading={deleteRecordLoading}
        dataSource={importRecord.logDeviceRecords}
        onClose={() => setRecordVisible(false)}
        handleDelete={deleteRecord}
      />
      <ImportModal
        open={importVisible}
        type={'MS'}
        resultId={id}
        refreshPage={() => {
          refreshRequest()
          getEchartsData()
          setRandom(Math.random())
        }}
        onClose={() => setImportVisible(false)}
        options={[{ label: t('邮件网关'), value: 'MS', disabled: false }]}
      />

      <CreateReport
        visible={reportVisible.visible}
        createLoading={createLoading}
        templateType={3}
        onConfirm={e => {
          createReport(e)
        }}
        onCancel={() => {
          setReportVisible(origin => ({ ...origin, visible: false }))
        }}
      />

      <DeleteModal
        onOk={handleDelete}
        visible={deleteVisible}
        title={t('删除任务')}
        text={t('此操作将永久删除该任务,是否继续?')}
        onCancel={() => {
          setDeleteVisible(false)
        }}
      />
      <DetailDrawer
        onClose={() => {
          setDetailDrawerVisible(false)
        }}
        dataList={resultResourceDetail}
        logList={resultResourceDetail?.device_security}
        visible={detailDrawerVisible}
        loading={detailLoading}
        resourceType={resourceType}
        attackTypeList={attackTypeList}
      />
    </DetailContainer>
  )
}

export default Detail

const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 16px;
  height: 100%;
  .case_name {
    &:hover {
      text-decoration: underline;
    }
  }
  .resource-type-url {
    color: #fff;
    background: #f8c649;
    padding: 1px 4px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 4px;
  }
  .resource-type-attach {
    color: #fff;
    background: #eb7e66;
    padding: 1px 4px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 4px;
  }
`

const TaskContent = styled.div`
  display: flex;
  align-items: center;

  .label {
    color: #86909c;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .ant-divider-vertical {
    margin: 0 19px;
  }

  .progress-info {
    flex: 1;
    display: flex;
    height: 100%;
    width: 50%;

    .is_finished {
      width: 50px;
      height: 18px;
      border-radius: 9px;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .ant-progress-line {
      font-size: 12px;
      width: 90%;
      margin-right: 20px;
    }

    .send_success_sum {
      color: #3586ff;
      font-size: 12px;
      flex-shrink: 0;
    }

    .send_fail_sum {
      color: #f5222d;
      font-size: 12px;
      flex-shrink: 0;
    }
  }
`

const TaskContentExpanded = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .task-info {
    flex: 1;
    height: 100%;
    border: 1px solid #e1e3e4;
    margin-right: 16px;
    border-radius: 8px;
    width: 50%;

    .sub-title {
      height: 35px;
      display: flex;
      align-items: center;
      padding-left: 6px;
      justify-content: space-between;

      .text {
        margin-left: 10px;
        font-weight: 500;
        font-size: 16px;
      }
    }

    .tab-box {
      width: 100%;
      height: 32px;
      display: flex;
      align-items: center;
      .left {
        width: 50%;
        min-width: 325px;
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid #e1e3e4;
      }
      .right {
        width: 50%;
        min-width: 325px;
        height: 100%;
        display: flex;
        align-items: center;
      }
      .tab-item {
        width: 84px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &.active {
          color: #4238c9;
          background: #e3e1f5;
        }
        &.disabled {
          color: #333333;
          cursor: not-allowed;
        }
      }
    }

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        height: 100%;
        font-size: 12px;
        width: 50%;
        border-right: 1px solid #e1e3e4;
        padding-left: 12px;
        padding-top: 12px;

        .left-item {
          margin-bottom: 10px;
          display: flex;
          align-items: center;

          .encode-items-wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            align-items: center;
          }

          .encode-item {
            display: inline-block;
            padding: 2px 4px;
            background: #f0f0f0;
            border-radius: 4px;
            font-size: 12px;
          }

          .more-dots {
            color: #666;
            margin-left: 2px;
          }

          .label {
            width: 85px;
            flex-shrink: 0;
            color: #86909c;
            font-size: 12px;
          }
          .text {
            font-size: 12px;
          }
        }
      }

      .right {
        flex: 1;
        height: 243px;
        padding-top: 12px;
        .tab-content {
          padding: 0 12px;
          overflow-y: scroll;
          height: 100%;
          .template {
            width: 100%;
            font-size: 13px;
            line-height: 18px;
            margin-bottom: 10px;
          }
        }
        .ant-tabs {
          height: 222px;
          border-radius: 6px;
          border: 1px solid #e1e3e4;

          .ant-tabs-nav {
            padding: 0 12px;
            background: #f1f3f5;
            margin-bottom: 8px;

            .ant-tabs-tab {
              color: #86909c;
            }

            .ant-tabs-tab.ant-tabs-tab-active {
              color: #4238c9;
            }
          }

          .tab-content {
            padding: 0 12px;
            overflow-y: scroll;
            max-height: 170px;
            max-width: 256px;

            .template {
              width: 100%;
              font-size: 12px;
              line-height: 18px;
            }
          }
        }
      }
    }
  }

  .progress-info {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e1e3e4;
    width: 50%;

    .status {
      width: 50px;
      height: 18px;
      border-radius: 9px;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .execute-box {
      .execute-tab-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 12px;
        .execute-item-title {
          height: 32px;
          background: #eeeff1;
          display: flex;
          align-items: center;
          .execute-item-title-text {
            font-size: 14px;
            color: #333;
            height: 100%;
            padding: 0 12px;
            display: flex;
            align-items: center;
            cursor: pointer;
          }
          .active {
            color: #4238c9;
            background: #e3e1f5;
          }
        }
        .execute-success-box {
          .success-sum {
            color: #67c23a;
          }
        }
      }
      .execute-tab-content {
        margin-top: 14px;
      }
    }

    .sub-title {
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e1e3e4;
      padding: 0 12px;

      .left {
        display: flex;

        .return-btn {
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          justify-items: center;
          align-items: center;
          margin-right: 12px;
          background: #fff;
          border: 0px;

          &:hover {
            border: 1px solid #4238c9;
            color: #4238c9;
          }
        }

        .return-icon {
          font-size: 12px;
        }

        .text {
          margin-left: 10px;
          font-weight: 500;
          font-size: 16px;
          margin-right: 6px;
          line-height: 24px;
        }

        .status {
          width: 50px;
          height: 18px;
          border-radius: 9px;
          font-size: 12px;
          text-align: center;
          line-height: 18px;
          flex-shrink: 0;
          margin-right: 10px;
        }
      }

      .create-time {
        color: '#666';
      }
    }

    .log-content {
      height: 283px;

      .log-panel {
        border-radius: 8px;
        height: 235px;
        display: flex;
        flex-direction: column;

        .header {
          height: 36px;
          border-radius: 8px 8px 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 16px;

          .left {
            height: 100%;
            display: flex;
            padding-top: 10px;

            span:first-child {
              width: 14px;
              height: 14px;
              background: #ff5f56;
              border-radius: 50%;
            }

            span:nth-child(2) {
              width: 14px;
              height: 14px;
              background: #ffbb2f;
              border-radius: 50%;
              margin: 0 8px;
            }

            span:last-child {
              width: 14px;
              height: 14px;
              background: #27c841;
              border-radius: 50%;
            }
          }

          .copy-btn .ant-typography .copy {
            color: #d0d0d0;

            &:hover {
              color: #fff;
            }
          }
        }

        .content {
          flex: 1;
          border-radius: 0 0 8px 8px;
          padding: 14px 12px;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;

          span {
            color: #fff;
            line-height: 20px;
          }
        }
      }
    }

    .information {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
      color: #666;
      font-size: 12px;

      .success-sum {
        color: #73a0fa;
      }

      .failed-sum {
        color: #f44f4f;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
`

const FilterIcon = styled(IconFont)<{ $filtered?: boolean }>`
  font-size: 14px;
  color: ${props => (props.$filtered ? '#4238C9' : '#999')};
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #4238c9;
  }
`
